
import React from "react";

import RadioSelector from "./RadioSelector";
import './ShareWidget.css';

class ShareWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const options = {
            'Low': !this.props['gif_disabled'],
            'Medium': !this.props['gif_disabled'],
            'High': !this.props['gif_disabled'],
        }
        return (
            <div id='share'>
                <button onClick={this.props['onscreenshot']}>Take Screenshot</button>
                <button 
                    onClick={() => this.props['oncreategif'](this.props['gif_quality'].toLowerCase())} 
                    disabled={this.props['gif_disabled']}>
                    Make GIF
                </button>

                <RadioSelector
                    label_text='GIF Quality:'
                    options={options}
                    selected={this.props['gif_quality']}
                    onchange={this.props['onchangegifquality']}
                />
            </div>
        );
    }
}

export default ShareWidget;